// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clickable[data-v-caabcd74]{cursor:pointer}.media-container[data-v-caabcd74]{background-color:var(--skeleton-loader-grey);position:relative}.media-container .media-badges[data-v-caabcd74]{position:absolute;top:var(--space-4);right:var(--space-4)}@supports (-moz-appearance:none){.media-container[data-v-caabcd74]:focus-within{outline:none;box-shadow:0 0 5px var(--link)}}", ""]);
// Exports
module.exports = exports;
